// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__2Ehpt","icon":"search_icon__1NIq_","input":"search_input__12dWU","button":"search_button__3SuS1"};